// 请假相关接口
import request from '@/api/request'
// 获取请假处理页面数据
export function getLeaveHandleApi(data: any) {
    let url = '/api/manager/userleave/detail';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 同意请假
export function chooseYesApi(data: any) {
    let url = '/api/manager/userleave/approve';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 驳回请假
export function chooseNoApi(data: any) {
    let url = '/api/manager/userleave/reject';
    return request({
        url: url,
        method: 'post',
        data
    })
}
// 获取查看详情页面信息
export function getDetailInfoApi(data: any) {
    let url = '/api/manager/userleave/detail';
    return request({
        url: url,
        method: 'post',
        data
    })
}
